import { createFileRoute } from '@tanstack/react-router'
import { claimTypesEnum } from 'User/utils/claims'
import WorkSearchTabs from 'Work/components/Work/search/WorkSearchTabs'

import { Guard } from './-guard'

export const Route = createFileRoute('/_worksearch')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <WorkSearchTabs />
        </Guard>
    ),
})
